export default "__VITE_ASSET__BpszZZTv__"